import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KlyantService } from '../shared/services/klyant.service';
import { KlyantUpdate } from '../shared/services/interfaces/klyant-update'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-klyant',
  templateUrl: './klyant.component.html',
  styleUrls: ['./klyant.component.scss']
})
export class KlyantComponent implements OnInit {  

  @Input() caseId: number = 0;
  @Input() existingClientId?:  number | null = null;
  @Input() existingMatterId?:  number | null = null;

  klyantUpdate: KlyantUpdate = <KlyantUpdate>{};  
  
  existingClients: any = [];
  isLoaded: boolean = false;
  isError: boolean = false;
  errorMessage: string = '';
  gettingCodeFromKlyant: boolean = false;

  addingToKlyant: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router, 
    activatedRoute: ActivatedRoute, 
    private klyantService: KlyantService) {

      activatedRoute.params.subscribe(params => {
        if(params['code']) {
          this.gettingCodeFromKlyant = true;
          this.getTokenFromUrlCode(params['code']);
        }
        if(params['error']) {
          this.gettingCodeFromKlyant = true;
          this.isError = true;
          this.errorMessage = params['error'];          
        }
      });

  }

  ngOnInit(): void {
      if (!this.gettingCodeFromKlyant) {
        this.getClientList();
      }
  }

  closeWindow() {
    window.close();
  }

  // Invoked on a callback after logging into Klyant
  getTokenFromUrlCode(code:any) {
    if (code != null) {
      this.klyantService.setTokenAfterCallback(code).subscribe(() => {
        this.closeWindow();
      });      
    }
  }

  getClientList() {
    this.klyantService.getClients().subscribe({
        next: (clients) => {
             this.existingClients = clients
             .filter(c => c.client_Code)
             .map(c => ({
                ...c,
                displayName: `${c.client_Code} - ${c.first_Name} ${c.last_Name} (${c.postal_Code})`
            }));
            this.isLoaded = true;
            this.isError = false;
        },
        error: (error) => {
            console.error("Error calling getClientList", error);
            this.isError = true;
            this.errorMessage = error.error;
        }
    });
}

  addClientAndMatter() {   
    this.addingToKlyant = true; 
    this.klyantUpdate.caseId = this.caseId;
    this.klyantService.addClientAndMatter(this.klyantUpdate).subscribe(response => {      
      this.isError = false;
      this.errorMessage = '';            
      this.activeModal.close(true);
    }, (error : any) => {
      console.log("ERROR calling addClientAndMatter");
      this.isError = true;
      this.errorMessage = error.error;
      this.addingToKlyant = false;
    });
  }

  updateClientAndMatter() {
    if (this.existingClientId) {
      this.klyantUpdate.caseId = this.caseId;
      this.klyantUpdate.clientId = this.existingClientId;
      this.klyantUpdate.matterId = this.existingMatterId;
      this.klyantService.updateClientAndMatter(this.klyantUpdate).subscribe(response => {
        this.isError = false;
        this.errorMessage = '';        
        this.activeModal.close(true);
      }, (error : any) => {
        console.log("ERROR calling updateClientAndMatter");
        this.isError = true;
        this.errorMessage = error.error;
      });
    }
  }

 
}
